import { objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import BootstrapCollapse from 'react-bootstrap/Collapse';
import kebabCase from 'lodash/kebabCase.js';
import { FieldGroup } from '../Form/FieldGroup.js';
import { Center, Collapse, Box, Image, Flex, Spacer } from '@chakra-ui/react';
import { CardTitle } from '../CardComponents/card-title/component.js';
import { FAIcon } from '../fa-icon/component.js';
import { AttentionGrabber } from '../attention-grabber/component.js';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';
import { CardMediaBox } from '../CardComponents/card-media-box/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
import { Card } from '../../core/components/Card/card.js';
import { CardHeader } from '../../core/components/Card/card-header.js';
import { CardBody } from '../../core/components/Card/card-body.js';
import { Layout } from '../../core/components/Layout/component.js';
import { CardActionBox } from '../CardComponents/card-action-box/component.js';
var _excluded = ["alwaysCollapsed", "alwaysExpanded", "attentionGrabber", "buttonConfig", "cardContentClasses", "chakra", "chevronPosition", "children", "className", "customActionBar", "data", "formWrapper", "hasMedia", "headerImageSize", "headerImageUrl", "onExpandedToggle", "overrideOverflowY", "size", "styleConfig", "title", "titleCentered", "titleIcon", "titleSize"];

var ConstructionCard = function ConstructionCard(_ref) {
  var _ref$alwaysCollapsed = _ref.alwaysCollapsed,
      alwaysCollapsed = _ref$alwaysCollapsed === void 0 ? false : _ref$alwaysCollapsed,
      _ref$alwaysExpanded = _ref.alwaysExpanded,
      alwaysExpanded = _ref$alwaysExpanded === void 0 ? false : _ref$alwaysExpanded,
      attentionGrabber = _ref.attentionGrabber,
      _ref$buttonConfig = _ref.buttonConfig,
      buttonConfig = _ref$buttonConfig === void 0 ? [] : _ref$buttonConfig,
      _ref$cardContentClass = _ref.cardContentClasses,
      cardContentClasses = _ref$cardContentClass === void 0 ? '' : _ref$cardContentClass,
      _ref$chakra = _ref.chakra,
      chakra = _ref$chakra === void 0 ? 'on' : _ref$chakra,
      _ref$chevronPosition = _ref.chevronPosition,
      chevronPosition = _ref$chevronPosition === void 0 ? 'right' : _ref$chevronPosition,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      customActionBar = _ref.customActionBar,
      data = _ref.data,
      _ref$formWrapper = _ref.formWrapper,
      formWrapper = _ref$formWrapper === void 0 ? false : _ref$formWrapper,
      _ref$hasMedia = _ref.hasMedia,
      hasMedia = _ref$hasMedia === void 0 ? false : _ref$hasMedia,
      _ref$headerImageSize = _ref.headerImageSize,
      headerImageSize = _ref$headerImageSize === void 0 ? 'small' : _ref$headerImageSize,
      headerImageUrl = _ref.headerImageUrl,
      onExpandedToggle = _ref.onExpandedToggle,
      overrideOverflowY = _ref.overrideOverflowY,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'full' : _ref$size,
      _ref$styleConfig = _ref.styleConfig,
      styleConfig = _ref$styleConfig === void 0 ? {
    background: 'white',
    shadow: 'none'
  } : _ref$styleConfig,
      title = _ref.title,
      _ref$titleCentered = _ref.titleCentered,
      titleCentered = _ref$titleCentered === void 0 ? false : _ref$titleCentered,
      titleIcon = _ref.titleIcon,
      _ref$titleSize = _ref.titleSize,
      titleSize = _ref$titleSize === void 0 ? 16 : _ref$titleSize,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(!!props.expanded),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState((styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.shadow) === 'light'),
      _useState4 = _slicedToArray(_useState3, 2),
      showShadow = _useState4[0],
      setShowShadow = _useState4[1];

  var dataAttributes = pickDataAttributes(props, 'construction-card');

  if (!dataAttributes['data-action']) {
    dataAttributes['data-action'] = title ? "open-".concat(kebabCase(title), "-card") : 'open-contstruction-card';
  }

  var showChevron = !alwaysExpanded && !alwaysCollapsed;
  var chakraDisabled = chakra === 'off';
  useEffect(function () {
    setExpanded(!!props.expanded);
  }, [props.expanded]);
  useEffect(function () {
    if (typeof onExpandedToggle === 'function') {
      onExpandedToggle(expanded);
    }
  }, [expanded]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(function () {
    setShowShadow((styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.shadow) === 'light');
  }, [styleConfig]);

  var getCardClasses = function getCardClasses() {
    return _formatClassName(['construction-card', "construction-card-".concat(size), "with-title-".concat(titleSize), "card-background-".concat(styleConfig.background), "card-shadow-".concat(showShadow ? 'light' : 'none'), {
      'card-expanded': alwaysExpanded || expanded
    }, {
      'fixed-height': !!styleConfig.fixedHeight
    }, {
      'title-centered': titleCentered
    }, {
      'centered-image': !!headerImageUrl
    }, className]);
  };

  var renderActions = function renderActions() {
    if (!buttonConfig && !customActionBar) {
      return null;
    }

    return customActionBar || /*#__PURE__*/React.createElement(CardActionBox, {
      chakra: chakra,
      buttons: buttonConfig,
      className: "card-actions",
      onClick: function onClick(event) {
        return event.stopPropagation();
      }
    });
  };

  var onMouseEnter = function onMouseEnter() {
    if ((styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.shadow) === 'hover') setShowShadow(true);
  };

  var onMouseLeave = function onMouseLeave() {
    if ((styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.shadow) === 'hover') setShowShadow(false);
  };

  var renderCardHeader = function renderCardHeader() {
    return /*#__PURE__*/React.createElement(Box, {
      onClick: showChevron ? function () {
        return setExpanded(!expanded);
      } : undefined
    }, headerImageUrl && /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(Image, {
      src: headerImageUrl,
      alt: "Card Image",
      boxSize: "110px",
      m: "2"
    })), /*#__PURE__*/React.createElement(Flex, {
      alignContent: 'flex-start'
    }, title && /*#__PURE__*/React.createElement(CardTitle, {
      size: titleSize,
      icon: titleIcon,
      titleDataAttributes: {
        optionalAttributes: {
          action: 'card-title'
        }
      }
    }, title, showChevron && /*#__PURE__*/React.createElement(FAIcon, {
      icon: expanded ? 'angle-down' : 'angle-right'
    })), attentionGrabber && /*#__PURE__*/React.createElement(AttentionGrabber, attentionGrabber), /*#__PURE__*/React.createElement(Spacer, null), !titleCentered && renderActions()));
  };

  var renderContentWrapper = function renderContentWrapper(children) {
    var classes = _formatClassName(['construction-card-content', {
      'card-expanded': !chakraDisabled && (alwaysExpanded || expanded)
    }, cardContentClasses]);

    return formWrapper ? /*#__PURE__*/React.createElement(FieldGroup, _extends({}, props, {
      data: data,
      className: classes
    }), children) : /*#__PURE__*/React.createElement("div", {
      className: classes
    }, children);
  };

  var renderCardContent = function renderCardContent() {
    if (alwaysCollapsed) {
      return null;
    }

    var content = renderContentWrapper(hasMedia ? /*#__PURE__*/React.createElement("div", {
      className: "media-container"
    }, children) : children);
    return alwaysExpanded || !chakraDisabled ? content : /*#__PURE__*/React.createElement(BootstrapCollapse, {
      "in": expanded
    }, content);
  };

  if (chakraDisabled) {
    return /*#__PURE__*/React.createElement("div", _extends({}, dataAttributes, {
      className: getCardClasses(),
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      style: {
        maxHeight: styleConfig.fixedHeight
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "card-header",
      onClick: showChevron ? function () {
        return setExpanded(!expanded);
      } : undefined,
      role: showChevron ? 'button' : undefined
    }, headerImageUrl && /*#__PURE__*/React.createElement("div", {
      className: "media-container"
    }, /*#__PURE__*/React.createElement(CardMediaBox, {
      chakra: "off",
      mediaUrl: headerImageUrl,
      mediaSize: headerImageSize,
      mediaPosition: "center"
    })), /*#__PURE__*/React.createElement("div", {
      className: _formatClassName(['main', "with-chevron-".concat(chevronPosition)])
    }, title && /*#__PURE__*/React.createElement(CardTitle, {
      chakra: "off",
      size: titleSize,
      icon: titleIcon,
      titleDataAttributes: {
        optionalAttributes: {
          action: 'card-title'
        }
      }
    }, title), showChevron && /*#__PURE__*/React.createElement(FAIcon, {
      icon: expanded ? 'angle-down' : 'angle-right',
      onClick: function onClick() {
        return setExpanded(!expanded);
      },
      additionalClasses: "card-chevron"
    }), attentionGrabber && /*#__PURE__*/React.createElement(AttentionGrabber, attentionGrabber)), !titleCentered && renderActions()), renderCardContent(), titleCentered && renderActions());
  } else {
    var isExpanded = expanded || alwaysExpanded;
    return /*#__PURE__*/React.createElement(Card, {
      dataObjectType: dataAttributes['data-object-type'],
      dataAction: dataAttributes['data-action'],
      overflowY: overrideOverflowY || 'auto',
      className: className
    }, /*#__PURE__*/React.createElement(CardHeader, {
      pb: isExpanded ? undefined : 5
    }, titleCentered || headerImageUrl ? /*#__PURE__*/React.createElement(Center, null, renderCardHeader()) : renderCardHeader()), /*#__PURE__*/React.createElement(Collapse, {
      startingHeight: ".75lh",
      "in": isExpanded,
      style: {
        overflow: isExpanded ? 'initial' : 'hidden'
      }
    }, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Layout, {
      width: "100%"
    }, renderCardContent(), titleCentered && renderActions()))));
  }
};

export { ConstructionCard };